import { useMemo } from "react";
import { tcgCardImageUrl } from "../../../utils/tcgImage";
import { TCG_RARITY_COUNTS, TCG_RARITY_ORDER } from "../constants";
import type { TcgCardItem, TcgRarityId } from "../types";

const buildCardFilename = (number: number) => `Card-${String(number)}.webp`;

export const buildTcgCardTitle = (rarityLabel: string, number: number) =>
  `${rarityLabel} Card ${String(number)}`;

export const useTcgCards = (rarityLabels: Record<TcgRarityId, string>) => {
  const cards = useMemo<TcgCardItem[]>(() => {
    return TCG_RARITY_ORDER.flatMap((rarity) => {
      const count = TCG_RARITY_COUNTS[rarity];
      const label = rarityLabels[rarity];

      return Array.from({ length: count }, (_, index) => {
        const number = index + 1;
        const filename = buildCardFilename(number);

        return {
          id: `${rarity}/${filename}`,
          rarity,
          number,
          filename,
          imageUrl: tcgCardImageUrl(rarity, filename),
          title: buildTcgCardTitle(label, number),
        };
      });
    });
  }, [rarityLabels]);

  const rarities = useMemo(
    () => TCG_RARITY_ORDER.filter((rarity) => TCG_RARITY_COUNTS[rarity] > 0),
    [],
  );

  return {
    cards,
    rarities,
  };
};
